import { MaterialSex } from "generated/graphql";

export const materialSexLabelMap: Record<MaterialSex, string> = {
  [MaterialSex.Agamosperm]: "Agamosperm",
  [MaterialSex.Female]: "Female",
  [MaterialSex.Hermaphrodite]: "Hermaphrodite",
  [MaterialSex.Male]: "Male",
  [MaterialSex.Unknown]: "Unknown",
};
